import React from 'react'
import { Navigate } from 'react-router-dom'

import { FLAGS } from './flags'
import useFeature from './useFeature'

/**
 * Which sales order screen /sales/order/create shows (T-029).
 *
 * The alternative was editing the sidebar, the dashboard shortcut and every
 * other link to point at /sales/order/new in week 2, then editing them all back
 * in week 3 when the old screen is deleted and the new one takes the original
 * URL. Two rounds of edits across the app to change one boolean, and a
 * salesperson's bookmark broken twice.
 *
 * Instead the existing URL keeps working and decides for itself. When the flag
 * comes out, this file and the /sales/order/new route go together, and
 * /sales/order/create points straight at the counter — which is the shape the
 * app should end up in anyway.
 *
 * `replace`, not a push: a redirected route in the history means Back sends you
 * to the URL you just came from, which redirects you forward again, and Back
 * stops working.
 */
export default function CounterRoute({ children }) {
    const [newCounter] = useFeature(FLAGS.NEW_COUNTER)
    return newCounter ? <Navigate to="/sales/order/new" replace /> : children
}

/**
 * The mirror image, on /sales/order/new: someone who has opted out and then
 * follows an old link, or a bookmark made during week 2, should land on the
 * screen they chose rather than the one they turned off.
 */
export function CounterOnlyRoute({ children }) {
    const [newCounter] = useFeature(FLAGS.NEW_COUNTER)
    return newCounter ? children : <Navigate to="/sales/order/create" replace />
}
